// import React, { useEffect } from "react";
// import { Container, Row, Col, Card } from "react-bootstrap";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faCheck } from "@fortawesome/free-solid-svg-icons";
// import CommonBreadcrumb from "./../../common_components/breadcrumb/CommonBreadcrumb";
// import { useState } from "react";
// import TrackShipment from "./../../common_components/common_modal/track_shipmment/TrackShipmment";
// import { Button } from "react-bootstrap";
// import "./OrderHistory.css";
// import { getAllOrder } from "../../../features/admin/product/productdetails/Slice";
// import { useDispatch, useSelector } from "react-redux";
// import { AllOrderStatus } from "../../../features/admin/common/Slice";
// import { getProduct } from "../../../features/admin/product/productdetails/Slice";
// import { AllAppSetup } from "../../../features/admin/common/Slice";

// const OrderHistory = ({ orderStatusId, allStatus }) => {
//   const dispatch = useDispatch();
//   const productsdetails = useSelector(
//     (state) => state.product.productdetails?.get_order_history,
//   );
//   const all_order_status = useSelector(
//     (state) => state?.common?.all_order_status,
//   );

//   const [selectedStatus, setSelectedStatus] = useState(null);

//   const [selectedUpdatedAt, setSelectedUpdatedAt] = useState("");

//   var HtmlToReactParser = require("html-to-react").Parser;
//   var htmlToReactParser = new HtmlToReactParser();

//   const product_details = useSelector((state) => state.product.productdetails);
//   const all_app_setup = useSelector((state) => state?.common?.all_app_setup);
//   const [qty, setQty] = useState(1);
//   const [triggerSubmit, setTriggerSubmit] = useState(null);

//   useEffect(() => {
//     dispatch(getAllOrder());
//     dispatch(AllOrderStatus());
//     dispatch(getProduct());
//     dispatch(AllAppSetup());
//   }, [dispatch]);

//   const breadcrumbItems = [
//     { label: "Profile", link: "/profile" },
//     { label: "Order History" },
//   ];

//   const [showModal, setShowModal] = useState(false);

//   const handleOpen = (statusId, updatedAt) => {
//     setSelectedStatus(statusId);
//     setSelectedUpdatedAt(updatedAt);
//     setShowModal(true);
//   };

//   const handleClose = () => setShowModal(false);

//   return (
//     <section className="order-plased-section order-history">
//       <CommonBreadcrumb items={breadcrumbItems} />

//       <Container className="py-5 conatiner-section">
//         <Row className="g-4 card-row justify-content-center">
//           {productsdetails && productsdetails.length > 0 ? (
//             productsdetails?.map((order, index) => (
//               <Col xs={12} md={12} lg={5} key={index} className="mb-5">
//                 <Card className="card-one p-3 shadow-sm border-0 rounded-4 h-100">
//                   <div className="succes-order">
//                     <h6>
//                       <img src="/images/profile/checked.png" alt="not" />
//                       Order Confirmed
//                     </h6>
//                     <p
//                       className="track-shipment-navigation"
//                       onClick={() =>
//                         handleOpen(
//                           order?.order_status_id,
//                           order?.order_details?.[0]?.updated_at,
//                         )
//                       }
//                     >
//                       Track Shipment
//                     </p>
//                   </div>

//                   <div className="d-flex justify-content-between small text-muted">
//                     <div className="order">
//                       <span>
//                         Serial No: <strong>{index + 1}</strong>
//                       </span>

//                       <span> Order Number </span>
//                       <strong># {order?.order_number}</strong>
//                     </div>

//                     <div className="order order-date">
//                       <span> Order Date & Time</span>
//                       <strong>
//                         {new Date(order?.created_at).toLocaleDateString(
//                           "en-US",
//                           {
//                             month: "short",
//                             day: "2-digit",
//                             year: "numeric",
//                           },
//                         )}
//                       </strong>

//                       <strong>
//                         {new Date(order?.created_at).toLocaleTimeString(
//                           "en-US",
//                           {
//                             hour: "2-digit",
//                             minute: "2-digit",
//                             hour12: true,
//                           },
//                         )}
//                       </strong>
//                     </div>
//                   </div>

//                   <div className="product-box">
//                     <div className="d-flex product-card align-items-center">
//                       <img src="/images/cart/productImg.png" alt="product" />
//                       <div className="product-details">
//                         <h6>{order?.order_details?.[0]?.product?.name}</h6>
//                         <p>
//                           {htmlToReactParser.parse(
//                             order?.order_details?.[0]?.product?.description,
//                           )}
//                         </p>
//                         <span>
//                           {order?.order_details?.[0]?.product?.power}{" "}
//                         </span>
//                       </div>
//                     </div>
//                   </div>

//                   <div className="price-section">
//                     <div className="price-row">
//                       <span>Quantity</span>
//                       <span className="price-rs">
//                         {order?.order_details?.[0]?.quantity}{" "}
//                         {order?.order_details?.[0]?.quantity > 1
//                           ? "Bottles"
//                           : "Bottle"}
//                       </span>
//                     </div>

//                     <div className="price-row">
//                       <span>Delivery Address</span>
//                       <span className="price-rs">
//                         {order?.user_address?.address2},
//                         {order?.user_address?.city?.[0]?.name},
//                         {order?.user_address?.pincode}
//                       </span>
//                     </div>
//                     <div className="price-row">
//                       <span>Subtotal</span>
//                       <span className="price-rs">₹. {order?.sub_total}/-</span>
//                     </div>

//                     <div className="price-row">
//                       <span>Standard Shipping</span>
//                       <span className="price-rs">
//                         ₹. {order?.shipping_charges}/-
//                       </span>
//                     </div>
//                     {/* 
//                   <div className="price-row">
//                     <span>Estimated Tax</span>
//                     <span className="price-rs">₹. 10</span>
//                   </div> */}

//                     <div className="price-row">
//                       <span>Grand Total</span>
//                       <span className="price-rs">
//                         ₹. {order?.grand_total}/-
//                       </span>
//                     </div>
//                   </div>

//                   <span className="order-box d-inline-flex align-items-start gap-2">
//                     <div className="dot">{order?.order_status?.name}</div>
//                   </span>
//                 </Card>
//               </Col>
//             ))
//           ) : (
//             <Col xs={12}>
//               <div className="text-center py-5 no-order-history">
//                 <h6 className="text-muted">No Order History Found</h6>
//               </div>
//             </Col>
//           )}
//         </Row>
//       </Container>

//       <TrackShipment
//         show={showModal}
//         handleClose={handleClose}
//         orderStatusId={selectedStatus}
//         allStatus={all_order_status}
//         updatedAt={selectedUpdatedAt}
//       />
//     </section>
//   );
// };

// export default OrderHistory;


import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Pagination,
} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import CommonBreadcrumb from "./../../common_components/breadcrumb/CommonBreadcrumb";
import TrackShipment from "./../../common_components/common_modal/track_shipmment/TrackShipmment";
import { Button } from "react-bootstrap";
import "./OrderHistory.css";

import { useDispatch, useSelector } from "react-redux";

import {
  getAllOrder,
  getProduct,
} from "../../../features/admin/product/productdetails/Slice";

import {
  AllOrderStatus,
  AllAppSetup,
} from "../../../features/admin/common/Slice";

const OrderHistory = ({ orderStatusId, allStatus }) => {
  const dispatch = useDispatch();

  const productsdetails = useSelector(
    (state) => state.product.productdetails?.get_order_history,
  );

  const all_order_status = useSelector(
    (state) => state?.common?.all_order_status,
  );

  const product_details = useSelector(
    (state) => state.product.productdetails,
  );

  const all_app_setup = useSelector(
    (state) => state?.common?.all_app_setup,
  );

  const [selectedStatus, setSelectedStatus] = useState(null);

  const [selectedUpdatedAt, setSelectedUpdatedAt] = useState("");

  const [qty, setQty] = useState(1);

  const [triggerSubmit, setTriggerSubmit] = useState(null);

  const [showModal, setShowModal] = useState(false);

  // Pagination State
  const [currentPage, setCurrentPage] = useState(1);

  // Show only 2 cards per page
  const cardsPerPage = 4;

  // Pagination Logic
  const totalPages = Math.ceil(
    (productsdetails?.length || 0) / cardsPerPage,
  );

  const startIndex = (currentPage - 1) * cardsPerPage;

  const currentOrders = productsdetails?.slice(
    startIndex,
    startIndex + cardsPerPage,
  );

  var HtmlToReactParser = require("html-to-react").Parser;

  var htmlToReactParser = new HtmlToReactParser();

  useEffect(() => {
    dispatch(getAllOrder());
    dispatch(AllOrderStatus());
    dispatch(getProduct());
    dispatch(AllAppSetup());
  }, [dispatch]);

  const breadcrumbItems = [
    { label: "Profile", link: "/profile" },
    { label: "Order History" },
  ];

  const handleOpen = (statusId, updatedAt) => {
    setSelectedStatus(statusId);
    setSelectedUpdatedAt(updatedAt);
    setShowModal(true);
  };

  const handleClose = () => setShowModal(false);

  return (
    <section className="order-plased-section order-history">
      <CommonBreadcrumb items={breadcrumbItems} />

      <Container className="py-5 conatiner-section">
        <Row className="g-4 card-row justify-content-center">
          {currentOrders && currentOrders.length > 0 ? (
            currentOrders?.map((order, index) => (
              <Col
                xs={12}
                md={12}
                lg={5}
                key={index}
                className="mb-5"
              >
                <Card className="card-one p-3 shadow-sm border-0 rounded-4 h-100">
                  <div className="succes-order">
                    <h6>
                      <img
                        src="/images/profile/checked.png"
                        alt="not"
                      />
                      Order Confirmed
                    </h6>

                    <p
                      className="track-shipment-navigation"
                      onClick={() =>
                        handleOpen(
                          order?.order_status_id,
                          order?.order_details?.[0]?.updated_at,
                        )
                      }
                    >
                      Track Shipment
                    </p>
                  </div>

                  <div className="d-flex justify-content-between small text-muted">
                    <div className="order">
                      <span>
                        Serial No:{" "}
                        <strong>
                          {startIndex + index + 1}
                        </strong>
                      </span>

                      <span> Order Number </span>

                      <strong>
                        # {order?.order_number}
                      </strong>
                    </div>

                    <div className="order order-date">
                      <span> Order Date & Time</span>

                      <strong>
                        {new Date(order?.created_at).toLocaleDateString(
                          "en-US",
                          {
                            month: "short",
                            day: "2-digit",
                            year: "numeric",
                          },
                        )}
                      </strong>

                      <strong>
                        {new Date(order?.created_at).toLocaleTimeString(
                          "en-US",
                          {
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: true,
                          },
                        )}
                      </strong>
                    </div>
                  </div>

                  <div className="product-box">
                    <div className="d-flex product-card align-items-center">
                      <img
                        src="/images/cart/productImg.png"
                        alt="product"
                      />

                      <div className="product-details">
                        <h6>
                          {
                            order?.order_details?.[0]?.product
                              ?.name
                          }
                        </h6>

                        <p>
                          {htmlToReactParser.parse(
                            order?.order_details?.[0]?.product
                              ?.description,
                          )}
                        </p>

                        <span>
                          {
                            order?.order_details?.[0]?.product
                              ?.power
                          }{" "}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="price-section">
                    <div className="price-row">
                      <span>Quantity</span>

                      <span className="price-rs">
                        {order?.order_details?.[0]?.quantity}{" "}
                        {order?.order_details?.[0]?.quantity > 1
                          ? "Bottles"
                          : "Bottle"}
                      </span>
                    </div>

                    <div className="price-row">
                      <span>Delivery Address</span>

                      <span className="price-rs">
                        {order?.address},
                        {order?.city},
                        {order?.user_address?.pincode}
                      </span>
                    </div>

                    <div className="price-row">
                      <span>Subtotal</span>

                      <span className="price-rs">
                        ₹. {order?.sub_total}/-
                      </span>
                    </div>

                    <div className="price-row">
                      <span>Standard Shipping</span>

                      <span className="price-rs">
                        ₹. {order?.shipping_charges}/-
                      </span>
                    </div>

                    <div className="price-row">
                      <span>Grand Total</span>

                      <span className="price-rs">
                        ₹. {order?.grand_total}/-
                      </span>
                    </div>
                  </div>

                  <span className="order-box d-inline-flex align-items-start gap-2">
                    <div className="dot">
                      {order?.order_status?.name}
                    </div>
                  </span>
                </Card>
              </Col>
            ))
          ) : (
            <Col xs={12}>
              <div className="text-center py-5 no-order-history">
                <h6 className="text-muted">
                  No Order History Found
                </h6>
              </div>
            </Col>
          )}
        </Row>

        {/* Pagination */}
        {productsdetails?.length > cardsPerPage && (
          <div className="d-flex justify-content-center mt-4">
            <Pagination>
              <Pagination.Prev
                disabled={currentPage === 1}
                onClick={() =>
                  setCurrentPage(currentPage - 1)
                }
              />

              {[...Array(totalPages)].map((_, index) => (
                <Pagination.Item
                  key={index}
                  active={currentPage === index + 1}
                  onClick={() =>
                    setCurrentPage(index + 1)
                  }
                >
                  {index + 1}
                </Pagination.Item>
              ))}

              <Pagination.Next
                disabled={currentPage === totalPages}
                onClick={() =>
                  setCurrentPage(currentPage + 1)
                }
              />
            </Pagination>
          </div>
        )}
      </Container>

      <TrackShipment
        show={showModal}
        handleClose={handleClose}
        orderStatusId={selectedStatus}
        allStatus={all_order_status}
        updatedAt={selectedUpdatedAt}
      />
    </section>
  );
};

export default OrderHistory;
